import { AfterViewInit, Component, Inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SessionItemRow, SessionItemsProvider } from '../../../sessions/providers/sessionItems-provider';
import {
  MAT_DIALOG_DATA, MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { Exercice } from "../../../common/models/exercice";
import { Organization } from "../../../common/models/organization";
import { ConfigProvider } from "../../../config-provider.service";
import { CurrentUser } from "../../../common/providers/current-user";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { NgIf } from "@angular/common";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import {
  SessionExerciceDurationComponent
} from "../../../sessions/components/session-exercice-duration/session-exercice-duration";
import {
  SessionExerciceRepeatComponent
} from "../../../sessions/components/session-exercice-repeat/session-exercice-repeat";

@Component({
  selector: 'exercices-exercice-view-dialog',
  providers: [],
  styleUrls: ['./exercice-view-dialog.scss'],
  standalone: true,
  imports: [
    MatDialogClose,
    NgIf,
    MatDialogTitle,
    MatIconButton,
    MatButton,
    MatTooltip,
    MatDialogContent,
    MatDialogActions,
    MatIcon,
    SessionExerciceDurationComponent,
    SessionExerciceRepeatComponent,
    TranslateModule
  ],
  templateUrl: './exercice-view-dialog.html'
})
export class ExercicesExerciceViewDialogComponent implements AfterViewInit {
    public readonly EXERCICE_TYPE_REPEAT = Exercice.TYPE_REPEAT;
    public readonly EXERCICE_TYPE_DURATION = Exercice.TYPE_DURATION;
    public data: SessionItemRow = {} as SessionItemRow;
    public organization: Organization = {} as Organization;

    constructor(
        public conf: ConfigProvider,
        public currentUser: CurrentUser,
        public utils: UtilsProvider,
        private _sessionItemsProvider: SessionItemsProvider,
        public dialog: MatDialogRef<ExercicesExerciceViewDialogComponent>,
        private _translater: TranslateService,
        @Inject(MAT_DIALOG_DATA) private _data :any
    ) {
        this.data = this._sessionItemsProvider.getEmptyItemExercice(_data.exerciceRow);

        if (_data.organization) {
            this.organization = _data.organization;
        }
    }

    public ngAfterViewInit() {
    }
}
